const documentTypeOptions = [
  { id: "salvage", label: "salvage", hex: "#F8AB53", hexLight: "#f8ab5341" }, 
  { id: "clean", label: "clean", hex: "#00CC52", hexLight: "#00cc523c" }, 
  { id: "non_repairable", label: "non_repairable", hex: "#f32f21", hexLight: "#f32f213a" },
  { id: "other", label: "other", hex: "#219AF3", hexLight: "#219cf34c" } 
];

  // API key
  const documentTypeAPIKey = "document"; 

  
  // Label
  const documentTypeLabel = "Document Type"; 
  
  export { documentTypeOptions, documentTypeAPIKey, documentTypeLabel };
  